import { ButtonIcon } from '@delmonicos/shared-design-system-react/src/components/button-icon/button-icon';
import { ButtonColor } from '@delmonicos/shared-design-system-react/src/components/button/button';
import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import * as cssTable from '@delmonicos/shared-design-system-react/src/components/table/table.module.scss';
import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { hasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';

import { ChannelContextProvider } from '../channel.context';

export interface ChannelListActionsCellProps
  extends CellContext<GatewayChannelWithChargePointInfoModel, unknown> {}

export const ChannelListActionsCell = (
  props: ChannelListActionsCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;
  const navigate = useNavigate();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  const userPermissions = useAppSelector(permissions);

  const canRead =
    userPermissions &&
    hasAccessTo(userPermissions, {
      resourceName: Resource.CHARGE_POINTS,
      action: ActionsByResource.CHARGE_POINTS.READ,
    });

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <ChannelContextProvider data={row.original}>
      <Stack direction="row" justifyContent="flex-end">
        {canRead && (
          <ButtonIcon
            icon="eye"
            color={ButtonColor.Ghost}
            onClick={() =>
              navigate(
                generatePath(APP_PATH.CHARGE_POINT.DETAILS, {
                  id: row.original.chargePointId,
                }),
              )
            }
            className={cssTable.displayOnHover}
          />
        )}
      </Stack>
    </ChannelContextProvider>
  );
};
